import React, { useEffect } from 'react'
import { Modal } from "react-bootstrap";
import { BaseUrl } from "../helper/BaseUrl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Icons from '../myIcon/Icons';
import DefaultButton from './DefaultButton';

export default function EnquiryPopup({ show, setShow }) {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const currentUrl = typeof window !== "undefined" ? window.location.href : "";
    const sourceUrl = typeof window !== "undefined" ? sessionStorage.getItem("source_url") || "" : "";

    const [errors, setErrors] = useState({
        name: "",
        phone: "",
        email: "",
        message: "",
        service: "",
    });

    const [formData, setFormData] = useState({
        form_type: "contact_form",
        name: "",
        email: "",
        phone: "",
        message: "",
        ip_address: "",
        service: "",
        agree: false,
        source_url: sourceUrl,
        current_url: currentUrl,
    })

    useEffect(() => {
        fetch("https://api64.ipify.org?format=json")
            .then(res => res.json())
            .then(data => {
                setFormData(prev => ({
                    ...prev,
                    ip_address: data.ip
                }));
            })
            .catch(err => {
                console.error("Failed to fetch IP address", err);
            });
    }, []);


    const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        let updatedValue = value;
        if (name === "phone") {
            updatedValue = value.replace(/\D/g, "");
        }
        if (name === "name") {
            updatedValue = value.replace(/[^a-zA-Z\s]/g, "");
        }

        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : updatedValue,
            source_url: sourceUrl,
            current_url: currentUrl,
        }));
        setErrors((prev) => ({
            ...prev,
            [name]: "",
            form: "",
        }));
    };

    const validate = () => {
        let newErrors = {};

        if (!formData?.name?.trim()) {
            newErrors.name = "Name is required";
        }
        if (!formData?.service) {
            newErrors.service = "Please select a service";
        }

        if (!formData?.phone) {
            newErrors.phone = "Mobile number is required";
        } else if (formData?.phone.length !== 10) {
            newErrors.phone = "Mobile number must be 10 digits";
        }

        if (!formData?.email) {
            newErrors.email = "Email is required";
        } else if (!emailRegex.test(formData?.email)) {
            newErrors.email = "Enter valid email";
        }

        if (!formData?.agree) {
            newErrors.agree = "Please accept privacy policy";
        }
        if (!formData?.message.trim()) {
            newErrors.message = "Message is required";
        }
        setErrors((prev) => ({
            ...prev,
            ...newErrors,
        }));

        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        try {
            setLoading(true);
            const response = await fetch(`${BaseUrl}api/contact/store`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });
            const result = await response.json();
            if (result.error === false) {
                toast.success(result.message || "Form submitted successfully");
                setShow(false);
                setFormData({
                    form_type: "contact_form",
                    name: "",
                    email: "",
                    phone: "",
                    message: "",
                    ip_address: "",
                    service: "",
                    agree: false,
                    source_url: sourceUrl,
                    current_url: currentUrl,
                });
                setTimeout(() => {
                    navigate("/thank-you");
                }, 1000);
            } else {
                setErrors((prev) => ({
                    ...prev,
                    form: result.message || "Submission failed",
                }));
            }
        } catch (error) {
            console.error("Error:", error);

            setErrors((prev) => ({
                ...prev,
                form: "Something went wrong while submitting the form.",
            }));
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Modal className="query-popup" show={show} onHide={() => setShow(false)} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Body>
                    <button className="popup-close" onClick={() => setShow(false)}><Icons name={"cross"} /></button>
                    <div className="row m-0 ">
                        <div className="col-lg-7 col-md-7 no-padd">
                            <div className="query-formbox">
                                <h4 className="heading">Talk to Our Document Management Experts</h4>

                                <form onSubmit={handleSubmit}>
                                    <div className="form-field half-field">
                                        <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Full Name*" className="form-control" required />
                                        {errors.name && <p className="error-message">{errors.name}</p>}
                                    </div>

                                    <div className="form-field half-field">
                                        <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email Address*" className="form-control" required />
                                        {errors.email && <p className="error-message">{errors.email}</p>}
                                    </div>

                                    <div className="form-field">
                                        <input name="phone" type="tel" value={formData.phone} onChange={handleChange} minLength={10} maxLength={10} required placeholder="Mobile*" className="form-control" />
                                        {errors.phone && <p className="error-message">{errors.phone}</p>}
                                    </div>

                                    <div className="form-field">
                                        <select name="service" value={formData.service} onChange={handleChange} className="form-control" required>
                                            <option value="">Select Any</option>
                                            <option value="Records Management">Records Management</option>
                                            <option value="Document Digitization">Document Digitization</option>
                                            <option value="Document Destruction">Document Destruction</option>
                                            <option value="Insolvency Storage">Insolvency Storage</option>
                                            <option value="Vault Storage">Vault Storage</option>
                                            <option value="Cloud Storage"> Cloud Storage</option>
                                            <option value="Others">Others</option>
                                        </select>
                                    </div>

                                    <div className="form-field">
                                        <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Your Message*" className="form-control" required />
                                        {errors.message && <p className="error-message">{errors.message}</p>}
                                    </div>

                                    <span>You may be contacted regarding Dox and Box products or services as per our Privacy Policy. Unsubscribe anytime.</span>
                                    <div className="popup-check-field">
                                        <input className="form-check-input" type="checkbox" name="agree" checked={formData.agree} onChange={handleChange} required />
                                        <span>I agree to the Dox and Box Privacy Policy.</span>
                                        {errors.agree && <p className="error-message privacy-error">{errors.agree}</p>}
                                    </div>
                                    

                                    <DefaultButton disabled={loading} onClick={handleSubmit} text={loading ? "submitting..." : "submit"} color />
                                </form>
                            </div>
                        </div>

                        <div className="col-lg-5 col-md-5 no-padd">
                            <div className="querypop-image">
                                <img src="/assets/images/query-image.webp" alt="Query" className="img-responsive" />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
